export default {
  startList: "unchecked"
};
